module.exports = __webpack_public_path__ + "img/fb.7c401ffd.svg";